import ContentPage from './ContentPage';

export default function AboutPage() {
  return (
    <ContentPage
      eyebrow="About us"
      title="The Story of Nayavarnam"
      lead="Rooted in craft, colour, and ceremony — Nayavarnam is a house of occasion wear made for the modern wardrobe."
    >
      <section>
        <h3>Who we are</h3>
        <p>
          Nayavarnam began with a simple belief: festive dressing should feel personal, polished, and
          joyfully wearable. From hand-finished details to carefully considered silhouettes, every
          piece is curated to celebrate you — whether it is a wedding, a festival, or an evening out.
        </p>
      </section>
      <section>
        <h3>What we stand for</h3>
        <ul>
          <li>Thoughtful fabrics and finishing that hold up beyond a single occasion.</li>
          <li>Edits and collections that feel like worlds you can step into.</li>
          <li>A shopping experience that is warm, clear, and respectful of your time.</li>
        </ul>
      </section>
      <section>
        <h3>Visit & reach us</h3>
        <p>
          Prefer to talk to us? Head to Contact on the home page, or write in through the form —
          we read every note and are happy to help with sizing, styling, or order questions.
        </p>
      </section>
    </ContentPage>
  );
}
